<template>
	<button
		class="
			ml-2
			bg-secondary
			text-white
			border-0
			rounded-sm
			p-2
			mt-2
			shadow-md
			outline-none
			cursor-pointer
			hover:text-primary
			focus:outline-none
		"
		v-bind:class="{ fullsize: fullsize }"
	>
		<slot></slot>
	</button>
</template>

<script>
export default {
	name: 'ButtonBlack',
	data: function () {
		return {}
	},
	props: {
		fullsize: Boolean
	}
}
</script>

<style scoped>
button:hover img {
	filter: invert(0.4) sepia(1) saturate(4) hue-rotate(180.6deg) brightness(0.9);
	transition-duration: 0.1s;
}
.fullsize {
	width: 100%;
}
</style>
